"use strict";
exports.__esModule = true;
exports.css = void 0;
exports.css = {
    visuallyHidden: '_1XrzR43T',
    focusable: '_3O6NNgCg',
    hidden: 'anrtUzBW',
    ' _key': 'base-widgets/base'
};
exports["default"] = exports.css;
